import { createReducer, on } from '@ngrx/store';
import { PageItem } from '../domain/page-item';
import * as Actions from './create-tray-screen.actions';
import { TrayTypeApiModel } from '@cxb/editor-stb-api';
import { finishLoading, startLoading } from '../app.actions';

export const featureKey = 'cxbCreateTrayScreen';

export interface FeatureState {
  loading: boolean;
  pageItem: PageItem;
  selectedCategory: string;
  selectedTrayType: TrayTypeApiModel;
}

export interface AppState {
  [featureKey]: FeatureState;
}

export const initialState: FeatureState = {
  loading: false,
  pageItem: undefined,
  selectedCategory: undefined,
  selectedTrayType: undefined,
};

export const reducer = createReducer(
  initialState,

  on(Actions.selectCategory, (state, action): FeatureState => ({ ...state, selectedCategory: action.selectedCategory })),

  on(Actions.selectTrayType, (state, action): FeatureState => ({ ...state, selectedTrayType: action.selectedTrayType })),

  on(Actions.loadCxbPageItemSuccess, (state, action): FeatureState => ({ ...state, loading: false, pageItem: action.pageItem })),

  on(
    startLoading,
    Actions.createCxbPageItem,
    Actions.loadCxbPageItem,
    Actions.updateCxbPageItem,
    Actions.deleteCxbPageItem,
    (state, action): FeatureState => ({ ...state, loading: true })
  ),

  on(
    finishLoading,
    Actions.createCxbPageItemSuccess,
    Actions.updateCxbPageItemSuccess,
    Actions.createCxbPageItemFail,
    Actions.loadCxbPageItemFail,
    Actions.updateCxbPageItemFail,
    Actions.deleteCxbPageItemFail,
    (state, action): FeatureState => ({ ...state, loading: false })
  ),

  on(Actions.deleteCxbPageItemSuccess, (state, action): FeatureState => ({ ...state, pageItem: undefined, loading: false })),

  on(Actions.clearCxbCreateTrayScreenState, (state): FeatureState => ({ ...state, loading: false, pageItem: undefined }))
);
